

import {GET_AdminOmrCodes} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminOmrCodes: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_AdminOmrCodes:
            return {
                AdminOmrCodes: action.omrcodesdata,
                loading :false
            }
        default:
            return state;
    }
}